"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _customProps = require("../../../../utils/customProps");

var _Tooltip = _interopRequireDefault(require("../../../../components/PageGrid/atoms/Tooltip/Tooltip"));

var _Button = _interopRequireDefault(require("../../../../components/PageGrid/atoms/Button/Button"));

/**
   * MuiButton controls Dialog open state from true to false.
   * More docs and demos at https://material-ui.com/api/button/
   */
var MuiButton = function MuiButton(props) {
  if (props.tooltip.length > 0) {
    return /*#__PURE__*/_react.default.createElement(_Tooltip.default, props.tooltip[0], /*#__PURE__*/_react.default.createElement(_Button.default, props));
  }

  return /*#__PURE__*/_react.default.createElement(_Button.default, props);
};

exports.MuiButton = MuiButton;
var _default = MuiButton;
exports.default = _default;
MuiButton.propTypes = {
  /** Tooltip to wrap button in to display help text */
  tooltip: function tooltip(props, propName, componentName) {
    var components = ['Tooltip'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  }
};
MuiButton.defaultProps = {
  tooltip: []
};